module.exports = __webpack_public_path__ + "static/media/gdt-color@2x.dca6cbc0.dca6cbc0.png";